import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowRight } = FiIcons;

function FeedbackPanel({ question, isCorrect, isLast, onNext }) {
  const reaction = isCorrect
    ? question.correctReaction
    : question.incorrectReaction;
  const explanation = isCorrect
    ? question.correctFeedback || question.feedback
    : question.incorrectFeedback || question.feedback;

  return (
    <motion.aside
      className={`feedback-panel ${isCorrect ? 'feedback-panel--correct' : ''}`}
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      role="status"
      aria-live="polite"
    >
      <span className="feedback-reaction">{reaction}</span>
      <p>{explanation}</p>
      <blockquote>{question.campaignLine}</blockquote>
      <button type="button" className="next-button" onClick={onNext}>
        {isLast ? 'Bekijk je resultaat' : 'Volgende vraag'}
        <SafeIcon icon={FiArrowRight} aria-hidden="true" />
      </button>
    </motion.aside>
  );
}

export default FeedbackPanel;